export function currentYear() {
    let d = new Date();
    d.setDate(d.getDate() - 180);
    return d.getFullYear();
}